export default {
    state: {
        branchDepartmentCreateUpdateModel: {
            id:     null,
            title:  null,
            isEdit: false
        },
        branchTerminalCreateUpdateModel: {
            id:     null,
            title:  null,
            isEdit: false
        },
        branchSignatoryAddByOneCModel: {
            title:  null
        },
        branchUserCreateUpdateModel: {
            id:     null,
            role:   null,
            type:   null,
            title:  null,
            isEdit: false
        },
    },
    getters: {
        getBranchTerminalCreateUpdateModel(state) {return state.branchTerminalCreateUpdateModel},
        getBranchDepartmentCreateUpdateModel(state) {return state.branchDepartmentCreateUpdateModel},
        getBranchSignatoryAddByOneCModel(state) {return state.branchSignatoryAddByOneCModel},
        getBranchUserCreateUpdateModel(state){return state.branchUserCreateUpdateModel},
    },
    mutations: {
        setBranchDepartmentCreateUpdateModel(state, data)   {return state.branchDepartmentCreateUpdateModel = data},
        setBranchTerminalCreateUpdateModel(state, data)     {return state.branchTerminalCreateUpdateModel   = data},
        setBranchSignatoryAddByOneCModel(state, data)       {return state.branchSignatoryAddByOneCModel     = data},
        setBranchUserCreateUpdateModel(state, data)         {return state.branchUserCreateUpdateModel       = data},
    },
    actions: {
        branchDepartmentCreateUpdateModel(context, data){context.commit('setBranchDepartmentCreateUpdateModel', data)},
        branchTerminalCreateUpdateModel(context, data)  {context.commit('setBranchTerminalCreateUpdateModel',   data)},
        branchSignatoryAddByOneCModel(context, data)    {context.commit('setBranchSignatoryAddByOneCModel',     data)},
        branchUserCreateUpdateModel(context, data)      {context.commit('setBranchUserCreateUpdateModel',       data)},
    }
}